<template>
    <b-jumbotron :header="title" header-level="5" fluid :class="{ 'jumbotron-light': lightTheme }" class="app-header">
        <template v-slot:lead>
            <span v-html="subtitle"></span>
        </template>
    </b-jumbotron>
</template>

<script>
export default {
    name: 'app-page-header',

    props: {
        title: {
            type: String,
            default: '',
        },

        subtitle: {
            type: String,
            default: '',
        },

        lightTheme: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
    $jumbotron-bg-color: $secondary;
    $jumbotron-light-bg-color: #4B2E6E;

    .app-header.jumbotron {
        background-image: url('~@/assets/img/Head_decor_wide@2x.png');
        background-color: $jumbotron-bg-color;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: bottom right;
        border-radius: 0;
        color: #ffffff;
        padding-top: 3.4rem;
        padding-bottom: 2.8rem;
        text-align: center;
        margin-bottom: 0;
        @include media-breakpoint-up(md) {
            text-align: left;
            background-position: bottom center;
        }
    }

    .app-header.jumbotron-light {
        background-image: url('~@/assets/img/Head_decor_wide@2x.png');
        background-color: $jumbotron-light-bg-color;
    }

    .app-header h1 {
        font-size: 42px;
        font-weight: 900;
        margin-bottom: 10px;
        @include media-breakpoint-up(md) {
            font-size: 52px;
        }
    }

    .app-header .lead {
        font-size: 18px;
        color: #FFFFFF;
        display: none;
        font-weight: 400;
        max-width: 735px;
        @include media-breakpoint-up(md) {
            display: block;
        }
        p {
            margin-bottom: 0;
        }
    }
</style>
